import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/insurance';

export type Tasks = Awaited<ReturnType<(typeof service)['getTasks']>>;

export function getTasksOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Tasks>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['insurances', 'tasks', guid, [search]],
    queryFn: async () => await service.getTasks(guid, search),
    initialData,
  });
}
